export default function LanguageIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.918 8.33317L19.5846 17.4998H17.7888L16.788 14.9998H13.3796L12.3805 17.4998H10.5855L14.2513 8.33317H15.918ZM8.83464 1.6665V3.33317H13.8346V4.99984H12.1946C11.5518 6.9349 10.5259 8.72068 9.17797 10.2507C9.77906 10.787 10.431 11.2634 11.1246 11.6732L10.4988 13.2382C9.6034 12.7303 8.76596 12.1265 8.0013 11.4373C6.51262 12.7846 4.74967 13.7933 2.8338 14.394L2.38714 12.7865C4.02867 12.2631 5.54132 11.3993 6.8263 10.2515C5.87521 9.17479 5.08302 7.96756 4.4738 6.6665H6.34047C6.80493 7.52389 7.36186 8.32784 8.0013 9.064C9.04306 7.86325 9.86405 6.48759 10.4263 5.00067L2.16797 4.99984V3.33317H7.16797V1.6665H8.83464ZM15.0846 10.7373L14.0455 13.3332H16.1221L15.0846 10.7373Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
